import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { ApiUrl } from 'Services/Services';
import { useParams } from 'react-router-dom';

function ViewBranch() {
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [radius, setRadius] = useState(1);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    address: '',
  });
  const [organization, setOrganization] = useState(null);
  const {id} = useParams()

  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapInstance = useRef(null);
  const circleRef = useRef(null);

  useEffect(() => {
    const FetchBranch = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/branches/${id}`);
        const branchData = response.data.data;

        setName(branchData.name);
        setPhoneNumber(branchData.phoneNumber);
        setRadius(branchData.radius);
        setLocation({
          latitude: parseFloat(branchData.latitude),
          longitude: parseFloat(branchData.longitude),
          address: branchData.address,
        });
        setOrganization(branchData.Organization);
      } catch (error) {
        console.log(error);
      }
    };

    FetchBranch();
  }, []);

  useEffect(() => {
    if (window.google) {
      initMap();
    }
  }, [location.latitude, location.longitude]);

  const initMap = () => {
    const position = {
      lat: location.latitude || 31.5204,
      lng: location.longitude || 74.3587,
    };

    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: position,
      zoom: 15,
      draggable: false,
      zoomControl: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
    });

    markerRef.current = new window.google.maps.Marker({
      position,
      map: mapInstance.current,
    });

    drawCircle(position.lat, position.lng, radius);
  };

  const drawCircle = (lat, lng, rad) => {
    if (circleRef.current) {
      circleRef.current.setMap(null);
    }

    circleRef.current = new window.google.maps.Circle({
      strokeColor: '#3b82f6',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#3b82f6',
      fillOpacity: 0.2,
      map: mapInstance.current,
      center: { lat, lng },
      radius: rad * 1000, // km to meters
    });
  };

  useEffect(() => {
    if (location.latitude && location.longitude) {
      drawCircle(location.latitude, location.longitude, radius);
    }
  }, [radius]);

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <div className="bg-white shadow-lg rounded-xl p-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Branch Details
        </h2>

        {/* Organization Info */}
        {organization && (
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-gray-700">Organization</h3>
            <p className="text-gray-800">{organization.name}</p>
            {organization.logo && (
              <img
                src={organization.logo}
                alt="Logo"
                className="w-24 h-24 object-cover mt-2 border rounded"
              />
            )}
          </div>
        )}

        <form className="space-y-6">
          {/* Branch Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Branch Name
            </label>
            <input
              type="text"
              value={name}
              disabled
              className="w-full border border-gray-300 bg-gray-100 rounded-md px-4 py-2"
            />
          </div>

          {/* Phone Number */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number
            </label>
            <input
              type="text"
              value={phoneNumber}
              disabled
              className="w-full border border-gray-300 bg-gray-100 rounded-md px-4 py-2"
            />
          </div>

          {/* Location & Map */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Location
            </label>
            <input
              type="text"
              value={location.address}
              disabled
              className="w-full mb-3 border border-gray-300 bg-gray-100 rounded-md px-4 py-2"
            />
            <div
              ref={mapRef}
              className="w-full h-96 rounded-lg border border-gray-300"
            ></div>
            {location.address && (
              <p className="text-sm text-gray-600 mt-2">
                📍 <strong>Selected Address:</strong> {location.address}
              </p>
            )}
          </div>

          {/* Radius */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Radius (km)
            </label>
            <input
              type="number"
              value={radius}
              disabled
              className="w-full border border-gray-300 bg-gray-100 rounded-md px-4 py-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default ViewBranch;
